import { Injectable } from '@angular/core';
import { Headers, Http, URLSearchParams } from '@angular/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { AppConstants } from '../core/app.constants';
import { BaseResponse, ScadenzaResponse, Scadenza } from "../core/core.component";

@Injectable()
export class ScadenzeFatturazioneService {

    constructor(private http: Http) { }

    getScadenze(srmToken: string, reforder?: string, dtscadfrom?: Date, dtscadto?: Date, dtfattfrom?: Date, dtfattto?: Date, ticket?: string): Observable<ScadenzaResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/scadenze";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let params: URLSearchParams = new URLSearchParams();
        const formattedDtScadFrom = this.formatDateToISO(dtscadfrom);
        const formattedDtFattFrom = this.formatDateToISO(dtfattfrom);
        const formattedDtScadTo = this.formatDateToISO(dtscadto);
        const formattedDtFattTo = this.formatDateToISO(dtfattto);
        let body = {
            reforder: reforder,
            dtscadfrom: formattedDtScadFrom,
            dtscadto: formattedDtScadTo,
            dtfattfrom: formattedDtFattFrom,
            dtfattto: formattedDtFattTo,
            ticket: ticket
        };

        return this.http.post(url, body, { search: params, headers: headers }).map((responseData) => responseData.json());
    }

    insertScadenza(srmToken, scadenza: Scadenza): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/scadenze/insert";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        const formattedDtScad = this.formatDateToISO(scadenza.dtscad);
        const formattedDtFatt = this.formatDateToISO(scadenza.dtfatt);
        let body = {
            reforder: scadenza.reforder,
            dsscad: scadenza.dsscad,
            dtscad: formattedDtScad,
            importo: scadenza.importo,
            giorni: scadenza.giorni,
            numfatt: scadenza.numfatt,
            dtfatt: formattedDtFatt,
            ticket: scadenza.ticket
        };
        return this.http.post(url, body, { headers: headers }).map((responseData) => responseData.json());
    }

    updateScadenza(srmToken, scadenza: Scadenza): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + '/scadenze/update/' + scadenza.idscad;
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        const formattedDtScad = this.formatDateToISO(scadenza.dtscad);
        const formattedDtFatt = this.formatDateToISO(scadenza.dtfatt);
        let body = {
            reforder: scadenza.reforder,
            dsscad: scadenza.dsscad,
            dtscad: formattedDtScad,
            importo: scadenza.importo,
            giorni: scadenza.giorni,
            numfatt: scadenza.numfatt,
            dtfatt: formattedDtFatt,
            ticket: scadenza.ticket
        };
        return this.http.put(url, body, { headers: headers }).map((responseData) => responseData.json());
    }


    deleteScadenza(srmToken, id: number): Observable<BaseResponse> {
        let url = environment.REST_SERVICE_BASE_URL + '/scadenze/delete/' + id;
        url = AppConstants.urlForNoCache(url);
        const headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        return this.http.delete(url, { headers: headers }).map((responseData) => responseData.json());
    }

    insertScadenzeTicketDaFatturare(srmToken: string, ticketIds: number[], dataFattura: Date, groupByOffer: boolean): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/scadenze/insertScadenzeTicketDaFatturare";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let body = {
            ticketIds: ticketIds,
            dataFattura: this.formatDateYMD(dataFattura),
            groupByOffer: groupByOffer
        };
        return this.http.post(url, body, { headers: headers }).map((responseData) => responseData.json());
    }


    private formatDateToISO(date: Date): string {
        if (!date) return '';
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + 1);
        return newDate.toISOString();
    }

    private formatDateYMD(date: Date): string {
        if (!date) return '';
        const d = new Date(date);
        const year = d.getFullYear();
        const month = d.getMonth() + 1;
        const day = d.getDate();
        const mm = month < 10 ? '0' + month : '' + month;
        const dd = day < 10 ? '0' + day : '' + day;
        return year + '-' + mm + '-' + dd;
    }
}




// WEBPACK FOOTER //
// ./src/app/service/scadenze.service.ts